/* luis.archives – add to bag without page reload + variant price switch */
(function () {
  var s = (window.theme && window.theme.strings) || {};
  var routes = (window.theme && window.theme.routes) || { cart_add_url: '/cart/add', cart_url: '/cart' };

  function updateCount() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function flash(btn, text, restore) {
    btn.textContent = text;
    setTimeout(function () {
      btn.textContent = restore;
      btn.classList.remove('is-loading');
    }, 1800);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    var msg = form.querySelector('[data-form-message]');
    if (btn) btn.classList.add('is-loading');

    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (res.ok) {
          updateCount();
          if (btn) flash(btn, s.added || 'Added', original);
          if (msg) msg.textContent = '';
        } else {
          var text = res.data && res.data.status === 422 ? (s.alreadyInBag || 'Already in bag') : (s.error || 'Error');
          if (btn) flash(btn, text, original);
          if (msg && res.data && res.data.description) msg.textContent = res.data.description;
        }
      })
      .catch(function () {
        /* fallback: normal form submit */
        form.removeAttribute('data-add-to-cart');
        form.submit();
      });
  });

  /* Variant select on product page */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-variant-select]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var root = select.closest('[data-product]');
    if (!root || !option) return;
    var price = root.querySelector('[data-price]');
    if (price && option.dataset.price) price.innerHTML = option.dataset.price;
    var btn = root.querySelector('[data-add-button]');
    if (btn) {
      var available = option.dataset.available === 'true';
      btn.disabled = !available;
      btn.textContent = available ? (s.addToBag || 'Add to bag') : (s.soldOut || 'Sold out');
    }
  });
})();
